var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"table-ref":"rentalduetable","url":'/report/property/due/' + _vm.rowData.id,"fields":_vm.fields,"title":"Tenancy Due","icon":"fa fa-asterisk","hide-org-badge":"","show-search":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }